export enum RouteLang {
    FR = 'fr', //default
    EN = 'en',
    NL = 'nl',
}